import { Config } from "react-plotly.js";

export type LOADING_STATE = "pending" | "fulfilled" | "rejected";
export const TOAST_TIMEOUT = 10000;
export const DEFAULT_LOCALE = "en-US";

export const DEFAULT_PLOTLY_CONFIG: Partial<Config> = {
  displayModeBar: true,
  displaylogo: false,
  responsive: true,
};

export const BREAKDOWN_TOOL = "breakdown-tool";
export const INJURY_RATE_TOOL = "injury-rate-tool";
export const SAIGE_POLICY_TOOL = "saige-policy-tool";

export const DEFAULT_SITE = "JFK8";

// New safety questions - these will appear first
const NA_POLICY_QUESTIONS = [
  "When can a permit-required confined space be reclassified?",
  "At what AQI level must N95s be provided?",
  "What are the requirements for a cool-down break area?",
  "What should I do after a PIT telemetry event?",
  "When is an ergonomic review required?",
];

const POLICY_QUESTIONS_BY_REGION: Record<string, string[]> = {
  na: NA_POLICY_QUESTIONS,
  eu: [
    "When is a Permit to Work required for electrical tasks?",
    "What assessment tools are used to evaluate MSD risk?",
    "When does a heat event require escalation?",
    "What does each lock color signify in the LOTO program?",
    "What are the steps to verify a zero-energy state?",
  ],
};

export const POLICY_QUESTIONS = (region?: string) =>
  POLICY_QUESTIONS_BY_REGION[region ?? ""] ?? NA_POLICY_QUESTIONS;

export const ERGONA_QUESTIONS = () => [
  "Total number of Ergona assessments created, broken down by type of assessment (REBA, RULA, Job Rotation)",
  "For Job Rotation assessment, count of draft assessment vs. completed assessment.",
  "For Ergona assessments in error status, what are the specific errors types in 2025 NA",
  "Unique user count for creating an Ergona assessment in 2025",
];

export const SAIGE_METRICS_QUESTIONS = () => [
  "Show me saige metrics data for Oct. 2025",
  "Show me saige weekly active users for 2025 Sep",
  "Show me the average sessions per user for saige for every day in August 2025",
  "Monthly active users for saige in 2025",
];

// For CloudWatch Rum Customer event
export const ALIAS = "alias";
export const SAFER_UPVOTE = "safer.upvote";
export const SAFER_DOWNVOTE = "safer.downvote";

export const NEW_CHAT_CLICK = "safer.new_chat";
export const HISTORY_QUESTION_CLICK = "safer.history_question";
export const FAVORITE_QUESTION_CLICK = "safer.favorite_question";

export const TOOL_NAME = "tool_name";
export const FAILED_QUESTION_COUNT = "safer.failed_question";

export const CONVERSATION_ID = "conversation_id";
export const USER_TEXT = "user_text";
export const IS_TEXT_ONLY = "is_text_only";
export const MESSAGE_ID = "message_id";
export const NO_MATCHED_TOOL = "safer.no_matched_tool";
export const IS_EMPTY_DATA = "is_empty_data";
export const TOTAL_SUCCESSFUL_QUESTION_COUNT =
  "safer.successful_posted_question";

export const CONFIRM_RESPONSE_YES = "confirm_response_yes";
export const CONFIRM_RESPONSE_NO = "confirm_response_no";
export const CONFIRM_RESPONSE_FAILURE = "confirm_response_fail";

export const DOWNVOTE_REASON = "downvote_reason";

export const DEFAULT_TABLE_PAGE_SIZE = 10;
export const PAGINATION_OPTIONS = [10, 50, 100, 200];

export const MAX_INPUT_LENGTH = 7000;

export const CSV_PREVIEW_MESSAGE =
  "Below tabular data is just a preview. Click Download CSV for all results.";
